import React from 'react';
import ServicePage from '../components/ServicePage';
import { pageContent as fb } from '../data/mock';
import { useContent } from '../context/ContentContext';

const Commercial = () => {
  const { pageContent = fb } = useContent();
  return <ServicePage data={pageContent.commercial} />;
};
export default Commercial;
